module.exports = __webpack_public_path__ + "img/tilde.bd113a56.svg";